export default __webpack_public_path__ + "static/media/Waiting-light.be9bacde.svg";